import { default as WscIconAnotherShortcut } from "./AnotherShortcut";
import { default as WscIconDobleArrow } from "./DobleArrow";
import { default as WscIconDobleArrowFromAz } from "./DobleArrowFromAZ";
import { default as WscIconDobleArrowFromZa } from "./DobleArrowFromZA";
import { default as WscIconPbpReplay } from "./PbpReplay";
import { default as WscIconReplay } from "./Replay";
import { default as WscIconPlayerGoToIn } from "./PlayerGoToIn";
import { default as WscIconPlayerSetIn } from "./PlayerSetIn";
import { default as WscIconPlayerSetOut } from "./PlayerSetOut";
import { default as WscIconPlayerPlaySegment } from "./PlayerPlaySegment";
import { default as WscIconPlayerGoToOut } from "./PlayerGoToOut";
import { default as WscIconArrowDown } from "./ArrowDown";
import { default as WscIconArrowUp } from "./ArrowUp";

const icons = {
  WscIconAnotherShortcut,
  WscIconDobleArrow,
  WscIconDobleArrowFromAz,
  WscIconDobleArrowFromZa,
  WscIconPbpReplay,
  WscIconReplay,
  WscIconPlayerGoToIn,
  WscIconPlayerGoToOut,
  WscIconPlayerSetIn,
  WscIconPlayerSetOut,
  WscIconPlayerPlaySegment,
  WscIconArrowDown,
  WscIconArrowUp,
};

export default icons;
